module.exports = __webpack_public_path__ + "img/sidebar-bg.6de432d0.jpg";